var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpandIcon = function SvgExpandIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 14,
    fill: "none",
    viewBox: "0 0 8 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5c34cd",
    d: "M6.293 5.121a1 1 0 1 0 1.414-1.414L4 0 .293 3.707a1 1 0 1 0 1.414 1.414L4 2.828zM1.707 8.707a1 1 0 0 0-1.414 1.414L4 13.828l3.707-3.707a1 1 0 1 0-1.414-1.414L4 11z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5c34cd",
    d: "M6.293 5.121a1 1 0 1 0 1.414-1.414L4 0 .293 3.707a1 1 0 1 0 1.414 1.414L4 2.828zM1.707 8.707a1 1 0 0 0-1.414 1.414L4 13.828l3.707-3.707a1 1 0 1 0-1.414-1.414L4 11z"
  })));
};
export default SvgExpandIcon;